import React from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
export var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  return React.createElement(StyledComponentsThemeProvider, {
    theme: theme
  }, React.createElement(React.Fragment, null, children));
};